import React, { useEffect, useState, useCallback } from 'react';
import ReactApexChart from 'react-apexcharts';

const SalesStatisticOne = ({ onViewAllSources }) => {
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const [chartSeries, setChartSeries] = useState([]);
    const [chartOptions, setChartOptions] = useState({
        // ... (your existing chart options)
    });

    const complaintSources = [
        { value: "", label: "All Sources" },
        { value: "Helpline", label: "Helpline" },
        { value: "Chatbot", label: "Chatbot" },
        { value: "Whatsapp", label: "Whatsapp" },
        { value: "Social Media", label: "Social Media" },
        { value: "By Post", label: "By Post" },
        { value: "By Hand", label: "By Hand" },
        { value: "By Email", label: "By Email" },
        { value: "Other", label: "Other" }
    ];

    
    const [selectedSource, setSelectedSource] = useState("");

    const fetchData = useCallback(async (source = "") => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${API_BASE_URL}/backend/complaints/complaints-month-wise-count`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: source ? JSON.stringify({ complaint_source: source }) : '{}'
        });

        if (response.ok) {
            const result = await response.json();
            if (result.status) {
                const categories = result.data.map(item => item.month_year);
                const data = result.data.map(item => item.count);
                setChartOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: { ...prevOptions.xaxis, categories }
                }));
                setChartSeries([{ name: "Calls by month", data }]);
            }
        } else {
            console.error('Failed to fetch data:', response.statusText);
        }
    }, [API_BASE_URL]);

    useEffect(() => {
        fetchData(selectedSource);
    }, [fetchData, selectedSource]);

    const handleSourceChange = (e) => {
        setSelectedSource(e.target.value);
    };

    return (
        <div className="col-xxl-6 col-xl-12">
          <div className="card h-100">
            <div className="card-body">
              <div className="d-flex flex-wrap align-items-center justify-content-between">
                <h6 className="text-lg mx-2 my-4 py-4">Monthly Complaint Stats</h6>
                
                <div className="d-flex gap-2">
                  <select 
                    className="form-select bg-base form-select-sm w-auto" 
                    value={selectedSource}
                    onChange={handleSourceChange}
                  >
                    {complaintSources.map((source, index) => (
                      <option key={index} value={source.value}>
                        {source.label}
                      </option>
                    ))}
                  </select>
                  
                  {/* Add this button */}
                  <button 
                    className="btn btn-outline-primary btn-sm"
                    onClick={onViewAllSources}
                  >
                    <i className="bi bi-bar-chart me-1"></i> View All Sources
                  </button>
                </div>
              </div>
              <ReactApexChart options={chartOptions} series={chartSeries} type="area" height={264} />
            </div>
          </div>
        </div>
      );
    };

export default SalesStatisticOne;